import React, { useEffect, useState } from "react";
import { BackButton, Toast } from "@egovernments/digit-ui-react-components";
import SubStep1 from "../../citizen/AVPForms/formComponents/map-submission/Step1/SubStep1";
import SubStep3 from "../../citizen/AVPForms/formComponents/map-submission/Step1/SubStep3";
import SubStep2 from "../../citizen/AVPForms/formComponents/map-submission/Step1/SubStep2";
import SubStep4 from "../../citizen/AVPForms/formComponents/map-submission/Step1/SubStep4";
import Step4 from "../../citizen/AVPForms/formComponents/map-submission/Step4";
import {
  MainWrapper,
  PrimaryTab,
  PrimaryTabs,
  PrimaryTabsWrapper,
  StyledDivider,
  SubTab,
  SubTabs,
  SubTabsWrapper,
} from "../../citizen/AVPForms/components/StyledComponent";
import ViewSidebarIcon from "@mui/icons-material/ViewSidebar";
import EmpTopBar from "../../../../../templates/ApplicationDetails/components/EmpReusableComp/EmpTopBar";
import ViewDocuments from "../../../../../templates/ApplicationDetails/components/EmpReusableComp/ViewDocuments";
import PrimaryContent from "../../../../../templates/ApplicationDetails/components/EmpReusableComp/PrimaryContent";
import RemarksEditor from "../../../../../templates/ApplicationDetails/components/EmpReusableComp/RemarksEditor";
import SubmitButton from "../../../../../templates/ApplicationDetails/components/EmpReusableComp/SubmitButton";
import { useDispatch } from "react-redux";
import { bindActionCreators } from "redux";
import { formMTDocActions } from "@egovernments/digit-ui-module-core/src/redux/actions";
import { Button } from "@mui/material";
import OnSelectActionDropdown from "../../../../../templates/ApplicationDetails/components/EmpReusableComp/OnSelectActionDropdown";
import DscLetters from "../DigitalSignLetters";
import useEmpNOC from "./useEmpNOC";
import DocumentSection from "../PurchasableFAR/DocumentSection";
import CollapseSection from "../../../../../templates/ApplicationDetails/components/EmpReusableComp/CollapseSection";
import NOCInfo from "./NOCInfo"; // <-- Import your NOCInfo component
import DocumentUploader from "../../../../../templates/ApplicationDetails/components/EmpReusableComp/DocumentUploader";
import PaymentHead from "../MapSubmission/PaymentHead";
import PaymentMemoTable from "../AllViewRemarks/PaymentChallan/PaymentMemoDetails";
import NocPaymentHead from "../MapSubmission/NocPaymentHead";
import { Loader } from "@egovernments/digit-ui-react-components";
import NocPaymentTable from "../AllViewRemarks/PaymentChallan/NocPaymentTable";

const EmpNOCPortal = ({ formData, submitAction, workflowDetails, userRolesArray, urlFormType, nocResponse }) => {
  const dispatch = useDispatch();
  const { initFormMTDocs } = bindActionCreators(formMTDocActions, dispatch);
  const [activeTab, setActiveTab] = useState(Digit?.SessionStorage.get("MS_CURRENT_TAB") || 0);
  const [selectedSubTab, setSelectedSubTab] = useState(Digit?.SessionStorage.get("MS_CURRENT_SUBTAB") || 0);
  const [selectedDocTab, setSelectedDocTab] = useState(0);
  const [nocToggle, setNocToggle] = useState(true);
  const [selectedNocTab, setSelectedNocTab] = useState(0);
  const [showToast, setShowToast] = useState(null);
  const [updatedInspectionReportData, setUpdatedInspectionReportData] = useState({});
  const isFeesEligible = ["AA", "AAP", "AP"].includes(userRolesArray?.[0]?.code);
  const isJE = userRolesArray?.[0]?.code === "JE";
  console.log(nocResponse, "nocRespoensepe");
  const {
    handleChange,
    currentTab,
    tabList,
    currentAction,
    onRadioActionSelect,
    Modal,
    tenantId,
    actions,
    handleSubmit,
    error,
    setError,
    updatedDocuments,
    setUpdatedDocuments,
    isCitizen,
    updateApiCall,
    t,
    isEE,
    isDa,
    remarks,
    setRemarks,
    getTabIndex,
    taxHead,
    setTaxHead,
    documentSection,
    isPreviewLoading,
    setIsPreviewLoading,
    iframeSrc,
    setIframeSrc,
    handleDocView,
    currentView,
    setCurrentView,
    initialUrl,
    developerRemarks,
    setDeveloperRemarks,
    drawingPdfs,
    initialPdfUrl,
    pdfIframeSrc,
    setPdfIframeSrc,
    setDataRecommendation,
    developerNocRemarks,
    setDeveloperNocRemarks,
    dataNocRecommendation,
    setDataNocRecommendation,
    dataRecommendation,
    setDeveloperRemarksDocument,
    setDataRecommendationDocument,
    setSelectedObjection,
    developerRemarksDocument,
    dataRecommendationDocument,
    callDrawingDetailsAPI,
    siteDrawingRemarksData,
    siteInspectionRemarksData,
    notingRemarksData,
    documentRemarksData,
    paymentHeadRemarksData,
    setCustomLetter,
    setTypeOfLetter,
    onDropDownSelect,
    setMapSubmissionAction,
    mapSubmissionAction,
    loader,
    params,
    setParams,
    clearParams,
    onSelect,
    handleNoWorkflow,
    mapSubNocDetails,
    setMapSubNocDetails,
    officerNocDetails,
    setOfficerNocDetails,
    isNoNoc,
    setIsNoNoc,
    handleNoWorkflowNoc,
    handleNoWorkflowPayNOC,
    isValidEmp,
    requestLetterId,
    currentFormData,
    nocOfficerRemarks,
    setNocOfficerRemarks,
    uploadedFiles,
    setUploadedFiles,
    nocFormData,
    searchNocRemarks,
    nocRemarksData,
  } = useEmpNOC(formData, workflowDetails, userRolesArray, urlFormType, nocResponse);
  // const isHideAction = ["REVERT_TO_APPLICANT", "APPROVED"]?.includes(formData?.status) && !isCitizen;
  const subTabLabels = [
    { label: "General Information" },
    { label: "Plot Details" },
    { label: "Applicant Information" },
    { label: "Geo Location" },
    // { label: "NOC Status" },
    // { label: "Fees" },
  ];
  const subTabDocLabels = [{ label: "Mandatory Documents" }, { label: "Conditional Documents" }];
  const subTabNocLabels = [{ label: "NOC Status" }, { label: "Select NOC" }];
  const nocSearchResult = Digit.SessionStorage.get("nocAppNo")?.nocSearchResult;
  const closeToast = () => {
    setShowToast(null);
  };

  useEffect(() => {
    if (formData?.documents?.length > 0) {
      initFormMTDocs(formData.documents);
    }
  }, []);
  const handleTabChange = async (nextTabNo) => {
    setActiveTab(nextTabNo);
    Digit.SessionStorage.set("MS_CURRENT_TAB", nextTabNo);
  };

  const handleSubTabChange = (nextSubTab) => {
    setSelectedSubTab(nextSubTab);
    Digit.SessionStorage.set("MS_CURRENT_SUBTAB", nextSubTab);
  };
  const handleSubDocTabChange = (nextSubTab) => {
    setSelectedDocTab(nextSubTab);
  };
  const handleSubNocTabChange = (nextSubTab) => {
    setSelectedNocTab(nextSubTab);
  };

  const [showNOCInfo, setShowNOCInfo] = useState(true); // <-- Add toggle state
  const renderContent = () => {
    console.log("activeTabFromRender", activeTab, currentFormData, requestLetterId);

    if (activeTab === 0) {
      switch (selectedSubTab) {
        case 0:
          return <SubStep1 formData={formData} handleSubTabChange={handleSubTabChange} isEmployee={!isCitizen} isNocModule={urlFormType === "NOC"} />;
        case 1:
          return <SubStep3 formData={formData} handleSubTabChange={handleSubTabChange} isEmployee={!isCitizen} isNocModule={urlFormType === "NOC"} />;
        case 2:
          return <SubStep2 formData={formData} handleSubTabChange={handleSubTabChange} isEmployee={!isCitizen} isNocModule={urlFormType === "NOC"} />;
        case 3:
          return <SubStep4 formData={formData} handleSubTabChange={handleSubTabChange} isEmployee={!isCitizen} isNocModule={urlFormType === "NOC"} />;
        // case 4:
        //   return <Step5 formData={formData} handleTabChange={handleTabChange} isEmployee={!isCitizen} />;
        default:
          return null;
      }
    } else if (activeTab === 1) {
      switch (selectedDocTab) {
        case 0:
          return (
            <React.Fragment>
              <div className="view-doc-container">
                <Button
                  variant="contained"
                  className="view-doc-btn"
                  onClick={handleDocView}
                  style={{ backgroundColor: "#157C4F", borderRadius: "15px", padding: "5px 10px" }}
                >
                  <span className="view-doc-icon">
                    <ViewSidebarIcon />
                  </span>
                  {currentView === "documents" ? "View all documents" : "View document section"}
                </Button>
              </div>
              {currentView === "documents" ? (
                <React.Fragment>
                  <DocumentSection
                    formData={params}
                    handleChange={handleTabChange}
                    setUpdatedDocuments={setUpdatedDocuments}
                    updatedDocuments={updatedDocuments}
                    setIsPreviewLoading={setIsPreviewLoading}
                    setDataRecommendation={setDataRecommendationDocument}
                    onSelect={onSelect}
                    handleNoWorkflow={handleNoWorkflow}
                    attachedDocs={params?.documents}
                    docType="mandatory"
                    detailData={documentRemarksData?.DetailDataRemarks}
                    developerRemarks={developerRemarksDocument}
                    setError={setError}
                    isNocModule={urlFormType === "NOC"}
                  />
                </React.Fragment>
              ) : (
                <ViewDocuments
                  documentSection={documentSection}
                  setIsPreviewLoading={setIsPreviewLoading}
                  iframeSrc={iframeSrc}
                  setIframeSrc={setIframeSrc}
                  initialUrl={initialUrl}
                />
              )}
            </React.Fragment>
          );
        case 1:
          return (
            <React.Fragment>
              <DocumentSection
                formData={params}
                handleChange={handleTabChange}
                setUpdatedDocuments={setUpdatedDocuments}
                updatedDocuments={formData?.documents}
                setIsPreviewLoading={setIsPreviewLoading}
                setDataRecommendation={setDataRecommendationDocument}
                onSelect={onSelect}
                handleNoWorkflow={handleNoWorkflow}
                attachedDocs={params?.documents || formData?.documents}
                docType="conditional"
              />
            </React.Fragment>
          );
        default:
          return null;
      }
    } else if (activeTab === 2) {
      return (
        <React.Fragment>
          <Step4 formData={formData} handleTabChange={handleTabChange} isEmployee={!isCitizen} isNocModule={urlFormType === "NOC"} />
        </React.Fragment>
      );
    } else if (activeTab === 3) {
      return (
        <React.Fragment>
          {/* Removed NOCTakeAction and replaced with toggle logic */}
          {!showNOCInfo && (
            <div style={{ display: "flex", justifyContent: "flex-end", margin: "12px 0" }}>
              <Button variant="contained" color={showNOCInfo ? "primary" : "secondary"} onClick={() => setShowNOCInfo((prev) => !prev)}>
                {showNOCInfo ? "Back to Take Action" : "View NOC Information"}
              </Button>
            </div>
          )}
          {!showNOCInfo ? (
            // <NOCTakeAction formData={formData} />
            <React.Fragment>
              <PrimaryContent formData={formData} handleChange={handleTabChange} serviceName="Map Submission" requestLetterId={requestLetterId} />

              {currentFormData?.applicationStatus === "FORWARD_TO_OFFICER_AFTER_DSC" && (
                <DscLetters formData={currentFormData} handleChange={handleTabChange} isEmployee={!isCitizen} viewDrawing={false} pdfType="LA" />
              )}

              {!isCitizen && (
                <CollapseSection title={"Terms & Condition"} defaultOpen={false}>
                  <RemarksEditor
                    setRemarks={setNocOfficerRemarks}
                    remarks={nocOfficerRemarks}
                    title={"Terms & Condition"}
                    setError={(errorState) => {
                      if (!nocOfficerRemarks || nocOfficerRemarks.trim() === "") {
                        setError(true);
                      } else {
                        setError(false);
                      }
                    }}
                    error={error}
                  />
                </CollapseSection>
              )}

              <OnSelectActionDropdown currentAction={currentAction || mapSubmissionAction || " "} onChange={onDropDownSelect} actions={actions} />

              {isCitizen && <RemarksEditor setRemarks={setRemarks} remarks={remarks} setError={setError} error={error} />}

              {/* <DocUploader uploadedFiles={uploadedFiles} setUploadedFiles={setUploadedFiles} maxFiles={4} /> */}
              <DocumentUploader uploadedFiles={uploadedFiles} setUploadedFiles={setUploadedFiles} maxFiles={4} />

              <SubmitButton handleSubmit={handleSubmit} isLoading={updateApiCall.isLoading} />
            </React.Fragment>
          ) : (
            <NOCInfo
              formData={formData}
              setShowNOCInfo={setShowNOCInfo}
              showNOCInfo={showNOCInfo}
              searchNocRemarks={searchNocRemarks}
              nocRemarksData={nocRemarksData}
            />
          )}
        </React.Fragment>
      );
    } else if (activeTab === 4) {
      return (
        <React.Fragment>
          <NocPaymentHead
            tenantId={tenantId}
            // formData={mapSubNocDetails}
            formData={currentFormData || nocSearchResult}
            setTaxHead={setTaxHead}
            taxHead={taxHead}
            empRole={userRolesArray?.[0]?.code}
            isFeesEligible={isFeesEligible}
            onSelect={onSelect}
            Modal={Modal}
            isValidEmp={isValidEmp}
            isEmployee={!isCitizen}
            handleNoWorkflowPayNOC={handleNoWorkflowPayNOC}
          />
          {!isCitizen && <NocPaymentTable nocPaymentDetails={currentFormData?.nocPaymentDetails} formData={params} />}
        </React.Fragment>
      );
    }
  };
  return (
    <MainWrapper>
      <div style={{ display: "flex", justifyContent: "space-between" }}>
        <BackButton />
        {nocFormData?.countDays !== undefined && (
          <span>
            <b>Time Left (Days)</b> : {nocFormData.countDays}
          </span>
        )}
      </div>

      <EmpTopBar formData={formData} />
      <PrimaryTabsWrapper>
        <PrimaryTabs value={activeTab} onChange={(e, i) => handleTabChange(i)} aria-label="Tab Group" variant="fullWidth">
          <PrimaryTab label="Application Form" />
          <PrimaryTab label="Document" />
          <PrimaryTab label="Drawing Details" />
          <PrimaryTab label="NOC Status" />
          <PrimaryTab label="Payment" />
        </PrimaryTabs>
      </PrimaryTabsWrapper>
      <StyledDivider />
      {/* Toggle Button for NOCInfo */}
      {activeTab === 0 && (
        <SubTabsWrapper>
          <SubTabs
            value={selectedSubTab}
            onChange={(e, i) => handleSubTabChange(i)}
            aria-label="Sub Tab Group"
            variant="scrollable"
            scrollButtons="auto"
          >
            {subTabLabels.map((tab, index) => (
              <SubTab key={index} label={tab.label} />
            ))}
          </SubTabs>
        </SubTabsWrapper>
      )}
      {activeTab === 1 && (
        <SubTabsWrapper>
          <SubTabs
            value={selectedDocTab}
            onChange={(e, i) => handleSubDocTabChange(i)}
            aria-label="Sub Tab Group"
            variant="scrollable"
            scrollButtons="auto"
          >
            {subTabDocLabels.map((tab, index) => (
              <SubTab key={index} label={tab.label} />
            ))}
          </SubTabs>
        </SubTabsWrapper>
      )}
      {renderContent()}
      {showToast && (
        <Toast error={showToast?.error} warning={showToast?.warning} label={t(showToast?.message)} onClose={closeToast} isDleteBtn={true} />
      )}
    </MainWrapper>
  );
};

export default EmpNOCPortal;
